import { camelCase } from '../util.js'
const works = [
  {
    title: '启韵-双十二双旦传播',
    desc: '启韵-双十二双旦传播',
    thumb: camelCase('cases-brand-illumcare-0'),
    zpic: [
      camelCase('cases-brand-illumcare-lazyload-01')
    ]
  },
  {
    title: '启韵-双十二双旦传播',
    desc: '启韵-双十二双旦传播',
    thumb: camelCase('cases-brand-illumcare-1'),
    zpic: [
      require('../../assets/cases-brand-illumcare-lazyload-11.mp4')
    ]
  }
]
export default {
  name: '启韵',
  logo: {
    default: camelCase('cases-brand-11'),
    active: camelCase('cases-brand-11-cover')
  },
  works
}
